import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import routes from '@/routes'

import Logo from '@/assets/Logo.svg'

import { Container } from './styles'
import clsx from 'clsx'

function SideBar() {
  const router = useRouter()

  return (
    <Container className="sidebar">
      <Logo className="logo" />

      <div className="icons">
        {routes.map(props => (
          <Link
            key={props.route}
            href={props.route}
            title={props.title}
            target={props.isExternal ? '_blank' : undefined}
            rel={props.isExternal ? 'noopener noreferrer' : undefined}
            className={clsx({
              actived: router.pathname === props.route,
              noSocialIcon: !props.socialIcon
            })}
          >
            {props.icon({})}
          </Link>
        ))}
      </div>
    </Container>
  )
}

export default SideBar
